import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Container } from 'shards-react';
import { connect } from 'react-redux';
import CustomTable from '../../../components/common/CustomTable';
import { delete_new_pay_component, get_new_pay_component_list } from '../../../redux/actions/subscriber/payroll';
import ConfirmAlert from '../../../components/common/ConfirmAlert';

const NewPayComponentHome = ({ newPayComponentList, get_new_pay_component_list, delete_new_pay_component }) => {
    const [formData, setFormData] = useState({
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
    });

    const history = useHistory();
    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });
    const { pageSize, pageSizeOptions } = formData;
    const [gridData, setGridData] = useState(newPayComponentList);

    const tableColumns = [
        {
            Header: "Name", accessor: "payComponentName", className: "justify-content-start",
        },
        {
            Header: "Category", accessor: "payComponentCategory", className: "justify-content-start"
        },
        {
            Header: "Category Label", accessor: "payComponentCategoryLabel", className: "justify-content-start"
        },
        {
            Header: "Type", accessor: "payComponentType", className: "justify-content-start"
        },
        {
            Header: "Action",
            accessor: "payComponentRefNum",
            maxWidth: 120,
            className: "text-center ",
            Cell: row => <>
                <span className="p-1"><img src="./icons/edit-square.svg" height="17.5" width="17.5" className='icon-cursor mr-2' role="button" onClick={() => {
                    history.push({
                        pathname: "/sub-add-edit-pay-component/" + row.original.payComponentRefNum,
                    });
                }}></img></span>
                <span className="p-1" role="button" onClick={() => {
                    deleteNewPayComponent(row.original.payComponentRefNum);
                }}><img src="./icons/cross-icon.png" height="17.5" width="17.5" className='icon-cursor' /></span>
            </>
        }
    ];

    useEffect(() => {
        get_new_pay_component_list();
    }, [])

    useEffect(() => {
        setGridData(newPayComponentList);
    }, [newPayComponentList])

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const deleteNewPayComponent = (payComponentRefNum) => {
        setConfirmAlert({
            ...confirmAlert,
            confirmMsg: 'Do you want to Delete the New Pay Component?',
            visible: true,
            onConfirm: async () => {
                await delete_new_pay_component(payComponentRefNum);
                get_new_pay_component_list();
            }
        })
    }

    return (
        <>
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Container fluid className="main-content-container p-4">
                <div className="w-100">
                    <CustomTable
                        pageSizeOptions={pageSizeOptions}
                        pageSize={pageSize}
                        onChange={onChange}
                        tableColumns={tableColumns}
                        AddButton="Add New Pay Component"
                        addPath="/sub-add-edit-pay-component/0"
                        tableData={gridData}
                        roundedTop={true}
                        showHeader />
                </div>
            </Container>
        </>
    )
}

const mapStateToProps = (state) => ({
    newPayComponentList: state.payroll.newPayComponentList
});

export default connect(mapStateToProps, { get_new_pay_component_list, delete_new_pay_component })
    (NewPayComponentHome)
